<template lang="html">
    <Header v-if="!isFullscreen" class="fix-head">
        <div class="logo">
            <div v-if="isMobile()" class="trigger" @click="handleTriggerTapped">
                <Icon class="c-icon" custom="c-icon-12"></Icon>
            </div>
            <img v-if="!isMobile()" src="/img/logo_s.png">   
            <span style="color: white; font-size: 20px; margin-left: 10px;">运营控制台</span>
        </div> 
        <div v-if="isLogin" class="info">
            <div class="user">
                <img class="avatar" :src="avatar"/>
                <span class="label">{{name}}</span>
            </div> 
            <!-- <div class="head-button" @click="handleEnterFullScreen">
                <Icon class="c-icon" custom="c-icon-15"></Icon>
                <span>全屏</span>
            </div>  -->
            <div class="head-button" @click="handleLogout">
                <Icon class="c-icon" custom="c-icon-16"></Icon>
            </div> 
        </div>
    </Header>
</template>

<script>
import constants from "../utils/constants";
import request from "../utils/request";
import util from "../utils/util";

export default {
    data() {
        return {
            name: "",
            avatar: "",
            isLogin: false,
            isFullscreen: false,
        };
    },
    mounted() {
        let self = this;
        self.name = util.getUserName();
        self.avatar = util.getUserAvatar();
        self.isLogin = !!self.name;
        
        ['fullscreenchange','webkitfullscreenchange','mozfullscreenchange'].forEach((item) => {
            document.addEventListener(item, () => {
                // console.log("111111 ~ file: HeadBar.vue ~ line 51 ~ document.addEventListener ~ item", item);
                let isFullScreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen || document.fullscreenElement;
                // console.log("111111 ~ file: HeadBar.vue ~ line 44 ~ document.addEventListener ~ isFullScreen", isFullScreen);
                self.isFullscreen = isFullScreen;
            });
        })

        self.$root.$on('Orientation_Change', function (orientation) {
            switch(orientation){ 
                case "landscape": 
                    self.isFullscreen = true;
                    break;
                case "portrait": 
                    self.isFullscreen = false;
                    break; 
            } 
        });
    },
    methods: {
        isMobile() {
            return util.isMobile();
        },
        handleTriggerTapped() {
            this.$root.$emit("Sidebar_Show", true);
        },
        handleLogout() {
            let self = this;
            self.$Modal.confirm({
                title: "退出登录",
                content: "确认退出登录？",
                onOk: () => {
                    request
                        .get(constants.apiHost + "/user/logout")
                        .then(function (result) {
                            util.removeLoginUserInfo();
                            util.redirect('/login.html');
                        })
                        .catch(function (error) {
                            self.$Message.error(
                                error.message ? error.message : "服务异常，请稍候再试。"
                            );
                        });
                },
                onCancel: () => {
                    // this.$Message.info("Clicked cancel");
                },
            });
        },
        handleEnterFullScreen() {
            if (document.body.requestFullscreen) {
                document.body.requestFullscreen();
            } else if (document.body.mozRequestFullScreen) {
                document.body.mozRequestFullScreen();
            } else if (document.body.webkitRequestFullscreen) {
                document.body.webkitRequestFullscreen();
            } else if (document.body.msRequestFullscreen) {
                document.body.msRequestFullscreen();
            }
        }
    },
};
</script>

<style lang="less">

.fix-head {
    position: fixed;
    z-index: 100;
    width: 100%;
    background-color: #2270CA !important;
    padding: 0 20px !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;

    .logo {
        display: flex;
        align-items: center;
        .trigger{
            padding-right: 20px;
            color: #FFFFFF;
            font-size: 14px;
        }
        img{
            height: 36px;
        }
    }

    .info {
        display: flex;
        >div{
            padding:0 10px;
        }
        .user {
            .label{
                color: #FFFFFF;
                margin-left: 8px;
                font-size: 14px;
            }
            .avatar {
                width: 32px;
                height: 32px;
                border-radius: 50%;
            }
        }
        .head-button {
            display: flex;
            align-items: center;
            color: #ffffff;
            padding:0 15px;
            font-size: 14px;
            &:hover {
                background-color: #2169bd;
                cursor: pointer;
            }
            span {
                padding-left: 5px;
            }
        }
    }
    
}

</style>
